const constants = {
  ADDRESS_STATUS_FAILURE: 'FAILURE',
};

export default constants;
